// NPM Imports
import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

// Internal Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DOCUMENTS, EVENTS } from "../../../constants";
import {
  updateHoveredDocumentSectionId,
  updateDocumentClickedComponentID,
  generateStripeButtonSessionId,
  getAllPaymentDetails,
  getAllPaymentDetailsWithHash,
  getAllPaymentDetailsWithPermaHash,
  stripeUserDetails,
  updateDraggedSection,
} from "../../../actions/DocumentActions";
import QuotationActions from "../../../actions/QuotationActions";
import { CURRENCY_SYMBOL } from "../../../constants/common";
import { AmplitudeUtils } from "../../../utils";
import { updateToolpaneView } from "../../../actions/ToolbarActions/toolbarActions";

// Destructuring
const { DOCUMENT_MODE } = DOCUMENTS;
const {
  setSectionDataForActivePaymentButtonInRightToolPane,
  updateToolPaneData,
} = QuotationActions;
const { amplitudeLogEvent } = AmplitudeUtils;

class StripePaymentContainer extends Component {
  state = {};

  componentDidMount = async () => {
    // Destructuring
    const {
      section,
      stripePaymentDetails,
      document,
      isSharedDocument,
    } = this.props;

    this.props.updateDraggedSection(null, null);

    if (stripePaymentDetails || section.data.stripeUserId) {
      const { sharingHash } = this.props.match.params;

      // Api call to get all the payment details of button
      const stripeUserIdForIntegration =
        (stripePaymentDetails && stripePaymentDetails.stripe_user_id) ||
        section.data.stripeUserId;
      if (!isSharedDocument) {
        if (stripeUserIdForIntegration && this.props.mode === "DOCUMENT") {
          await this.props.getAllPaymentDetails(
            document.id,
            stripeUserIdForIntegration,
          );
        }
      } else if (stripeUserIdForIntegration) {
        const { pathname } = window.location;
        const check = pathname.split("/")[1];
        let isPerma = false;
        let permaHash = null;

        if (this.props.match.params.newPermalinkUrl) {
          isPerma = true;
          permaHash = this.props.match.params.newPermalinkUrl.split("-").pop();
        } else if (check === "perma") {
          isPerma = true;
          permaHash = this.props.match.params.sharingHash;
        }

        if (isPerma) {
          await this.props.getAllPaymentDetailsWithPermaHash(
            document.id,
            document.created_by.id,
            permaHash,
          );
        } else {
          await this.props.getAllPaymentDetailsWithHash(
            document.id,
            document.created_by.id,
            sharingHash,
          );
        }
      }
    }

    if (this.props.stripeFlag && !stripePaymentDetails && !isSharedDocument) {
      this.props.stripeUserDetails();
    }
  };

  _handleOnClick = event => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if (this.props.showFormMode) {
      const { docStage, section, isComponentActive } = this.props;
      if (docStage === "DRAFT" && section && !isComponentActive) {
        this.props.updateDocumentClickedComponentID(
          section.id,
          false,
          section.type,
        );
        this.props.setSectionDataForActivePaymentButtonInRightToolPane(
          this.props.section,
        );
        this.props.updateToolpaneView(section, "DOCUMENT");
      }
    } else {
      const { isComponentActive, isLocked, section } = this.props;
      if (!isLocked && !isComponentActive && section) {
        this.props.createDocSectionRef(React.createRef());
        this.props.updateDocumentClickedComponentID(
          section.id,
          false,
          section.type,
        );
        this.props.setSectionDataForActivePaymentButtonInRightToolPane(
          this.props.section,
        );
        this.props.updateHoveredDocumentSectionId(section.id, null);
        this.props.updateToolpaneView(section, "DOCUMENT");
      }
    }
  };

  _invokStripe = () => {
    const { stripeButtonSessionId } = this.props;

    // stripe promise
    const stripePromise = window.Stripe(
      `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`,
      {
        stripeAccount: stripeButtonSessionId.stripe_id,
      },
    );
    return stripePromise;
  };

  _handleOnBlur = event => {
    event.preventDefault();
    if (
      this.props.isComponentActive &&
      this.props.preventClickedComponentIdUpdateInfo
    ) {
      this.props.updateDocumentClickedComponentID(null, true, null);
      this.props.setSectionDataForActivePaymentButtonInRightToolPane({});
    }
  };

  _onPaymentButtonClick = async () => {
    if (this.props.isSharedDocument) {
      // Destructuring
      const { sectionID, match, document, section } = this.props;

      const { pathname } = window.location;
      const check = pathname.split("/")[1];
      let isPerma = false;
      let permaHash = null;

      if (this.props.match.params.newPermalinkUrl) {
        isPerma = true;
        permaHash = this.props.match.params.newPermalinkUrl.split("-").pop();
      } else if (check === "perma") {
        isPerma = true;
        permaHash = this.props.match.params.sharingHash;
      }

      // Payload to send payment details upon payment button click
      const stripePaymentData = {
        doc_id: document.id,
        sharing_hash: isPerma ? "NA" : this.props.match.params.sharingHash,
        perma_hash: isPerma ? permaHash : "NA",
        currency: section.data.currency.value.toLowerCase(),
        amount: parseFloat(section.data.amount),
        success_url: `${window.location.origin + match.url}?success=true`,
        cancel_url: `${window.location.origin + match.url}?cancel=true`,
        payment_detail: sectionID,
        user_id: document.created_by.id,
        meta_data: {
          user_name: document.created_by.name,
          email: document.created_by.user_email,
          amount: section.data.amount.toString(),
          doc_no: document.docNo,
          doc_name: document.name,
        },
      };

      // Sending Payment details for checkout
      await this.props.generateStripeButtonSessionId(stripePaymentData);
      const myStripePromise = this._invokStripe();
      myStripePromise.redirectToCheckout({
        sessionId: this.props.stripeButtonSessionId.session_id,
      });

      amplitudeLogEvent(EVENTS.EVENT_NAMES.STRIPE_PAYMENT_BUTTON_CLICKED, {
        paymentDetails: {
          doc_id: document.id,
          sharing_hash: this.props.match.params.sharingHash,
          currency: section.data.currency.value.toLowerCase(),
          amount: section.data.amount,
          payment_detail: sectionID,
        },
      });
    }
  };

  render() {
    // Destructuring
    const {
      section,
      sectionID,
      isComponentActive,
      isSharedDocument,
      isLocked,
      stripePaymentDetails,
    } = this.props;

    // Details of the specific button
    let buttonData = null;
    if (
      this.props.stripePaymentButtonDetails &&
      this.props.stripePaymentButtonDetails.length
    ) {
      buttonData = this.props.stripePaymentButtonDetails.filter(
        elem => elem.payment_detail === this.props.sectionID,
      )["0"];
    }

    return (
      <Fragment>
        {DOCUMENT_MODE.TEMPLATE === this.props.mode && (
          <div className="clause-product-name">
            <span className="label-text">
              {" "}
              <i className="edit-icon">
                <FontAwesomeIcon icon={["far", "info-circle"]} />
              </i>{" "}
              Payment button placeholder
            </span>
          </div>
        )}
        <div
          data-test="stripe-payment-container"
          id={sectionID}
          className={`button-alignment remove-from-export ${
            isComponentActive && !this.props.showFormMode
              ? "active-payment-button"
              : ""
          } ${!isSharedDocument && !isLocked ? "add-hover" : ""} `}
          onClick={this._handleOnClick}
          onKeyPress={() => {}}
          onBlur={this._handleOnBlur}
          tabIndex={0}
          role="button">
          <button
            data-test="stripe-payment-container-btn"
            className={`payment-button ${
              (!stripePaymentDetails && !isSharedDocument) ||
              (stripePaymentDetails && !stripePaymentDetails.is_active) ||
              (buttonData &&
                buttonData.payment_status &&
                buttonData.payment_status === "paid")
                ? "payment-disabled"
                : ""
            }`}
            onClick={this._onPaymentButtonClick}
            type="button">
            <span>{`${section.data.payNowLabel} - ${
              CURRENCY_SYMBOL[section.data.currency.value]
            }${(Math.round(section.data.amount * 100) / 100).toFixed(2) ||
              "0.00"}`}</span>
            <div className="secure-pay">
              {!stripePaymentDetails && !isSharedDocument
                ? "Not configured"
                : "Secured by Stripe"}
            </div>
          </button>
        </div>
        {buttonData &&
        buttonData.payment_status &&
        buttonData.payment_status === "paid" ? (
          <div className="date-of-payment remove-from-export">
            <div>
              <FontAwesomeIcon icon={["fas", "check-circle"]} color="green" />
            </div>
            <div className="date-of-payment-complete">
              Payment made on{" "}
              {`${new Date(`${buttonData.payment_time}`)
                .toString()
                .split(" ")
                .slice(1, 3)
                .join(" ")} ${new Date(
                `${buttonData.payment_time}`,
              ).toLocaleTimeString({}, { hour12: true })}`}
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { sectionID, mode } = props;
  let data = [];
  let section;
  let isComponentActive = false;
  let preventClickedComponentIdUpdateInfo;
  let docStage;
  let showFormMode;

  const {
    document,
    components,
    preventClickedComponentIdUpdate,
    clickedActiveComponentId,
    stripePaymentDetails,
    stripeButtonSessionId,
    stripePaymentButtonDetails,
    stripeFlag,
  } = state.DocumentStore;

  const { isOpen } = state.ToolPaneStore;

  if (DOCUMENT_MODE.TEMPLATE === mode) {
    preventClickedComponentIdUpdateInfo = preventClickedComponentIdUpdate;
    section = components[sectionID].content;
    data = components[sectionID].content;
    if (clickedActiveComponentId === sectionID) isComponentActive = true;
  }

  if (DOCUMENT_MODE.DOCUMENT === mode) {
    const {
      document: { stage, showForm },
    } = state.DocumentStore;
    docStage = stage;
    showFormMode = showForm;
    preventClickedComponentIdUpdateInfo = preventClickedComponentIdUpdate;
    section = components[sectionID].content;
    data = components[sectionID].content;
    if (clickedActiveComponentId === sectionID) isComponentActive = true;
  }

  return {
    document,
    section,
    data,
    isOpen,
    isComponentActive,
    preventClickedComponentIdUpdateInfo,
    docStage,
    showFormMode,
    stripePaymentDetails,
    stripeButtonSessionId,
    stripePaymentButtonDetails,
    stripeFlag,
  };
};

const mapDispatchToProps = {
  setSectionDataForActivePaymentButtonInRightToolPane,
  updateHoveredDocumentSectionId,
  updateDocumentClickedComponentID,
  generateStripeButtonSessionId,
  getAllPaymentDetails,
  getAllPaymentDetailsWithHash,
  getAllPaymentDetailsWithPermaHash,
  updateToolpaneView,
  stripeUserDetails,
  updateToolPaneData,
  updateDraggedSection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(StripePaymentContainer));



// WEBPACK FOOTER //
// ./src/components/DocumentItems/StripePaymentContainer/StripePaymentContainer.js